var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopSignDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2684_6899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4262 28.418C63.287 31.8614 64.3479 35.8093 64.3479 40.0006C64.3479 53.4441 53.4436 64.3484 40.0001 64.3484C35.8088 64.3484 31.861 63.2875 28.4175 61.4267L61.4262 28.418Z",
    fill: "url(#paint0_linear_2684_6899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5828 18.5741L18.5741 51.5828C16.7132 48.1393 15.6523 44.1915 15.6523 40.0002C15.6523 26.5567 26.5567 15.6523 40.0002 15.6523C44.1915 15.6523 48.1393 16.7132 51.5828 18.5741Z",
    fill: "url(#paint1_linear_2684_6899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9443 0 0 17.9426 0 40C0 62.0574 17.9443 80 40 80C62.0574 80 80 62.0574 80 40C80 17.9426 62.0574 0 40 0ZM40 76.5217C19.8609 76.5217 3.47826 60.1374 3.47826 40C3.47826 19.8626 19.8609 3.47826 40 3.47826C60.1374 3.47826 76.5217 19.8626 76.5217 40C76.5217 60.1374 60.1374 76.5217 40 76.5217Z",
    fill: "url(#paint2_linear_2684_6899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3027 18.3218C53.2226 17.7774 52.8922 17.3044 52.4087 17.0435C48.6174 14.9948 44.3253 13.9131 40 13.9131C25.6157 13.9131 13.9131 25.6157 13.9131 40C13.9131 44.327 14.9966 48.6192 17.0435 52.4105C17.3044 52.8922 17.7792 53.2261 18.3218 53.3044C18.4053 53.3166 18.4905 53.3235 18.574 53.3235C19.0313 53.3235 19.4748 53.1427 19.8035 52.814L52.8122 19.8053C53.2018 19.414 53.3826 18.8661 53.3027 18.3218ZM19.0887 48.6087C17.9722 45.8922 17.3913 42.9566 17.3913 40C17.3913 27.534 27.534 17.3913 40 17.3913C42.9548 17.3913 45.8905 17.974 48.6087 19.0887L19.0887 48.6087Z",
    fill: "url(#paint3_linear_2684_6899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6782 26.6969C61.1408 26.6204 60.5843 26.8013 60.1964 27.1874L27.1877 60.1961C26.7982 60.5856 26.6173 61.1334 26.6973 61.6778C26.7756 62.2221 27.1077 62.6952 27.5912 62.9561C31.3825 65.0048 35.673 66.0865 39.9999 66.0865C54.3843 66.0865 66.0869 54.3839 66.0869 39.9995C66.0869 35.6743 65.0051 31.3821 62.9564 27.5891C62.6956 27.1074 62.2208 26.7752 61.6782 26.6969ZM39.9999 62.6082C37.0451 62.6082 34.1095 62.0256 31.3912 60.9108L60.9112 31.3908C62.026 34.1091 62.6086 37.0448 62.6086 39.9995C62.6086 52.4656 52.466 62.6082 39.9999 62.6082Z",
    fill: "url(#paint4_linear_2684_6899)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2684_6899",
    x1: 46.3827,
    y1: 28.4179,
    x2: 46.3827,
    y2: 64.3477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2684_6899",
    x1: 33.6176,
    y1: 15.6523,
    x2: 33.6176,
    y2: 51.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2684_6899",
    x1: 40,
    y1: -0.00019548,
    x2: 40,
    y2: 79.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2684_6899",
    x1: 33.6172,
    y1: 13.913,
    x2: 33.6172,
    y2: 53.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2684_6899",
    x1: 46.3828,
    y1: 26.6796,
    x2: 46.3828,
    y2: 66.0857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2684_6899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSignDriver);
export default __webpack_public_path__ + "static/media/stop-sign-driver.84a5726333f06082c3bebc915c53abc5.svg";
export { ForwardRef as ReactComponent };